import { render, staticRenderFns } from "./ButtonWithOptions.vue?vue&type=template&id=404e1772&"
import script from "./ButtonWithOptions.vue?vue&type=script&lang=js&"
export * from "./ButtonWithOptions.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports